/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type vocabularyListItem_item$ref: FragmentReference;
export type vocabularyListItem_item = {|
  +id: string,
  +name: ?string,
  +value: ?string,
  +description: ?string,
  +canDelete: ?boolean,
  +$refType: vocabularyListItem_item$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "vocabularyListItem_item",
  "type": "Vocabulary",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "value",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canDelete",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1b5c00039b950c12f7802eb9fc24c711';
module.exports = node;



// WEBPACK FOOTER //
// src/components/vocabulary/__generated__/vocabularyListItem_item.graphql.js